import { useState, useEffect } from "react"
import {
  ocrElementsToFlowHtml,
  OcrElement,
} from "../../component/tiptapEditor"
import { buildSubParts } from "../../utils/subParts"
import { BulkQuestionData, ProcessedQuestionContent } from "../QuestionPreview/types"

const toOcrElements = (data: unknown): OcrElement[] =>
  Array.isArray(data) ? (data as OcrElement[]) : []

export const useQuestionDataV2 = (data: BulkQuestionData) => {
  const [processedContent, setProcessedContent] = useState<
    ProcessedQuestionContent[]
  >([])

  useEffect(() => {
    if (data.documents && data.documents.length > 0) {
      const subPartsText = data.sub_parts_labels || ""
      const processed = data.documents.map((item) => ({
        ...item,
        solution: item.solution_result?.data
          ? ocrElementsToFlowHtml(toOcrElements(item.solution_result.data))
          : "",
        answer: item.answer_result?.data
          ? ocrElementsToFlowHtml(toOcrElements(item.answer_result.data))
          : "",
        question: item.question_result?.data
          ? ocrElementsToFlowHtml(toOcrElements(item.question_result.data))
          : "",
        marking_scheme: item.marking_scheme_result?.data
          ? ocrElementsToFlowHtml(toOcrElements(item.marking_scheme_result.data))
          : "",
        subject: data.subject || "",
        chapter: data.chapter || "",
        chapter_id: data.chapter_id ?? null,
        topic: data.topic || "",
        topic_id: data.topic_id ?? null,
        level_2_id: data.level_2_id ?? null,
        level_2_name: data.level_2_name ?? null,
        level_3_id: data.level_3_id ?? null,
        level_3_name: data.level_3_name ?? null,
        level_4_id: data.level_4_id ?? null,
        level_4_name: data.level_4_name ?? null,
        complexity: data.complexity || "",
        grade: data.grade || "",
        source: data.source || "",
        year: data.year != null ? String(data.year) : "",
        marks: data.marks != null ? String(data.marks) : "",
        subPartsText,
        sub_parts: buildSubParts(subPartsText, []),
        question_status: "published" as const,
      }))

      setProcessedContent(processed)
    } else if (data.documents && data.documents.length === 0) {
      setProcessedContent([])
    }
  }, [
    data.documents,
    data.subject,
    data.topic,
    data.topic_id,
    data.chapter,
    data.chapter_id,
    data.level_2_id,
    data.level_3_id,
    data.level_4_id,
    data.complexity,
    data.grade,
    data.source,
    data.year,
    data.marks,
    data.sub_parts_labels,
  ])

  const updateContent = (updatedContent: ProcessedQuestionContent[]) => {
    setProcessedContent(updatedContent)
  }

  return {
    processedContent,
    updateContent,
  }
}
